// ReportSubmission.jsx

import React from 'react';
import '../CSS/ReportSubmissionTable.css'; // Import your custom CSS
import Sidebar from '../Component/Sidebar'

function ReportSubmission() {
  // Sample data (replace with your real data)
  const data = [
    {
      employeeName: 'Genaro Seth',
      designation: 'Report Specialist',
      shift: 'Morning',
      date: '2023-02-25',
      high: 30,
      medium: 10,
      low: 0
    },
    {
      employeeName: 'Jenny Sagar',
      designation: 'Quality Innovator',
      shift: 'Morning',
      date: '2023-02-25',
      high: 28,
      medium: 15,
      low: 2
    },
    {
      employeeName: 'Guadalupe Barba',
      designation: 'Data Analyst',
      shift: 'Morning',
      date: '2023-02-25',
      high: 25,
      medium: 10,
      low: 1
    },
    {
      employeeName: 'Arnold Cabera',
      designation: 'Process Analyst',
      shift: 'General',
      date: '2023-02-25',
      high: 30,
      medium: 5,
      low: 0
    }
  ];

  return (
    <div className='index-box'>
    <Sidebar />
    <div className="report-submission-container">
      {/* Header / Title Section */}
      <div className="report-submission-header">
        <h2 className="report-submission-title">Report Submission Count</h2>
        <button className="report-submission-export-btn">Export to Excel</button>
      </div>

      {/* Table Section */}
      <table className="report-submission-table">
        <thead>
          <tr>
            <th className="report-submission-th">
              <div className="report-submission-header-cell">
                <span>Employee Name</span>
                <select className="report-submission-select-employee">
                  <option>All Employees</option>
                  {/* Populate dynamically if needed */}
                </select>
              </div>
            </th>

            <th className="report-submission-th">
              <div className="report-submission-header-cell">
                <span>Designation</span>
                {/* No filter in this column; you can add one if needed */}
              </div>
            </th>

            <th className="report-submission-th">
              <div className="report-submission-header-cell">
                <span>Shift</span>
                <select className="report-submission-select-shift">
                  <option>All Shifts</option>
                  {/* Populate dynamically if needed */}
                </select>
              </div>
            </th>

            <th className="report-submission-th">
              <div className="report-submission-header-cell">
                <span>Date</span>
                <input
                  type="date"
                  className="report-submission-date-picker"
                />
              </div>
            </th>

            <th className="report-submission-th">High</th>
            <th className="report-submission-th">Medium</th>
            <th className="report-submission-th">Low</th>
          </tr>
        </thead>
        <tbody>
          {data.map((row, idx) => (
            <tr key={idx} className="report-submission-tr">
              <td className="report-submission-td">{row.employeeName}</td>
              <td className="report-submission-td">{row.designation}</td>
              <td className="report-submission-td">{row.shift}</td>
              <td className="report-submission-td">{row.date}</td>
              <td className="report-submission-td">{row.high}</td>
              <td className="report-submission-td">{row.medium}</td>
              <td className="report-submission-td">{row.low}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
    
    </div>
  );
}

export default ReportSubmission;
